import { withChartLayout } from 'components/common';
import HomeMedication from 'components/features/chart/patient-data/home-medication/HomeMedication';

const HomeMedicationPage = withChartLayout('HomeMedication')(HomeMedication);
export default HomeMedicationPage;
